var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { createSlice } from '@reduxjs/toolkit';
import { Location, Contact } from '../../classes/index';
var initialState = { location: __assign({}, new Location()), serviceEventId: "", contact: __assign({}, new Contact()) };
var serviceEventSlice = createSlice({
    name: 'serviceEvent',
    initialState: initialState,
    reducers: {
        saveSchedule: function (state, action) {
            state.schedule = action.payload;
        },
        saveContact: function (state, action) {
            state.contact = action.payload;
        },
        saveLocation: function (state, action) {
            state.location = action.payload;
        },
        saveServiceEvent: function (state, action) {
            // Redux Toolkit allows us to write "mutating" logic in reducers. It
            // doesn't actually mutate the state because it uses the Immer library,
            // which detects changes to a "draft state" and produces a brand new
            // immutable state based off those changes
            state.serviceEventId = action.payload.serviceEventId;
        }
    },
});
export var saveSchedule = (_a = serviceEventSlice.actions, _a.saveSchedule), saveContact = _a.saveContact, saveLocation = _a.saveLocation, saveServiceEvent = _a.saveServiceEvent;
export default serviceEventSlice.reducer;
